module.exports = __webpack_public_path__ + "static/media/cloudLogo.4a38177b.png";